import { z } from 'zod'
import type { LayerAssignment, LayerAssignmentBatchResult } from '#/domain/catalog/LayerAssignment'

export const LayerAssignmentDtoSchema = z
  .object({
    LayerId: z.string(),
    LayerCategoryId: z.string(),
    LayerCategoryName: z.string().optional(),
    DisplayOrder: z.number(),
    Zindex: z.number(),
  })
  .transform((raw): LayerAssignment => ({
    LayerId: raw.LayerId,
    LayerCategoryId: raw.LayerCategoryId,
    LayerCategoryName: raw.LayerCategoryName,
    DisplayOrder: raw.DisplayOrder,
    Zindex: raw.Zindex,
  }))

export type LayerAssignmentResponseDto = z.input<typeof LayerAssignmentDtoSchema>

export function toDomain(raw: LayerAssignmentResponseDto): LayerAssignment {
  return LayerAssignmentDtoSchema.parse(raw)
}

export const LayerAssignmentBatchResultDtoSchema = z
  .object({
    Assigned: z.array(LayerAssignmentDtoSchema),
    Failed: z.array(z.object({ LayerId: z.string(), Reason: z.string() })),
  })
  .transform(
    (raw): LayerAssignmentBatchResult => ({
      Assigned: raw.Assigned,
      Failed: raw.Failed,
    }),
  )

export type LayerAssignmentBatchResultResponseDto = z.input<typeof LayerAssignmentBatchResultDtoSchema>

export function toDomainBatch(
  raw: LayerAssignmentBatchResultResponseDto,
): LayerAssignmentBatchResult {
  return LayerAssignmentBatchResultDtoSchema.parse(raw)
}
